import styled from 'styled-components';

import { breakpoint } from 'DesignLibrary/global';

interface MomentPageLayoutProps {
  topic?: string;
}

export const StorybookRuntimeContainer = styled.div`
  max-width: 1082px;
  width: 100%;
  margin: 0 auto;
  padding-top: var(--sizing-xxl);

  .dreamcast-scope {
  }
`;

export const MomentPageLayoutWrapper = styled.div<MomentPageLayoutProps>`
  .inner-wrapper {
    max-width: 100%;
    background: linear-gradient(to top, #f5fcff 0%, #ffffff 100%);
  }
`;

export const StorybookRuntimeWrapper = styled.section<any>`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: var(--sizing-lg);
  border-radius: 24px;
  box-shadow: 0px 2px 8px 0px #2f2f5229;
  background: #ffffff;
  padding: 16px;
  display: flex;
  flex-direction: column;
  video {
    border-radius: 16px;
  }

  ${breakpoint.TABLET} {
    display: grid;
    grid-template-columns: 2fr 1fr;
  }

  ${breakpoint.DESKTOP} {
  }

  ${breakpoint.WIDEDESKTOP} {
    grid-template-columns: 2fr 1fr;
  }
`;

export const MomentSidebarContainer = styled.div`
  padding: var(--sizing-xl) 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const RatingsContainer = styled.div`
  padding-top: var(--sizing-lg);
  padding-bottom: var(--sizing-xxl);
  text-align: center;
  max-width: 415px;
  margin: 0 auto;
`;
